import WebServiceRequest from "../../Api/WebServiceRequest";

class MessageGetChattersUserId extends WebServiceRequest {
  constructor(context) {
    super(context);
  }
  setData(data) {
    super.setTag("Message/GetChatterUserIds?mainFlatId=" + data.mainFlatId);
  }
}
export default MessageGetChattersUserId;
